// extracted by mini-css-extract-plugin
module.exports = {"team":"TeamProfile_team"};